<div class="store-category-page">
  <div class="store-category-header">
    <div>
      <mat-icon class="store-category-icon">{{ config.icon }}</mat-icon>
    </div>
    <h1 class="store-category-title">{{ config.title }}</h1>
    <p class="store-category-subtitle">{{ config.subtitle }}</p>
  </div>
  <div class="store-category-content">
    @if (config.title === 'Travel') {
      <div class="content-row quiz-cta">
        <ddc-appstore-btn-small></ddc-appstore-btn-small>
        <span class="quiz-cta-text">Travel mode is only available on the Daydic app</span>
      </div>
    } @else {
      @if (config.title === 'Academy') {
        <div class="ddc-dic-chooser">
          <ddc-elem-chooser-one
            [_allElems]="daydicTopics"
            [_elemType]="'dictionary'"
            [_label]="'Choose a topic'"
            [_labelIcon]="'book'"
            [_placeholder]="'Select a topic...'"
            [_type]="'single'"
            (selectedElemsChange)="updateSelectedTopic($event)"
          ></ddc-elem-chooser-one>
        </div>
      }

      <div class="ddc-content-card-scroll" *ngIf="dictionaries && dictionaries.length" (scroll)="onScroll($event)">
        <ddc-content-card
          *ngFor="let dictionary of dictionaries"
          [content]="dictionary"
          [dynamicRoute]="'/library/dic/' + dictionary.id + '/' + dictionary.owner.username"
          (clicked)="onCardClick(dictionary)"
        ></ddc-content-card>
        <div class="load-more-indicator" *ngIf="loadingMore">Loading more...</div>
        <div class="scroll-down-indicator" *ngIf="!loadingMore && hasMore">Scroll down to load more</div>
      </div>
      <p class="store-category-coming-soon" *ngIf="!loading && (!dictionaries || !dictionaries.length)">
        No dictionaries found for this topic. Please choose another topic.
      </p>
      <p class="store-category-coming-soon" *ngIf="loading">Loading dictionaries...</p>
    }
  </div>
</div>
